module.exports = __webpack_public_path__ + "img/profile.a589b2a4.png";